import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import AlertTitle from '@mui/material/AlertTitle';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as router from '../../constants/router';
import * as info from '../../appRedux/actions/info';

function CommunicationManagement(props) {
  const [comment, setComment] = useState('');
  const [subject, setSubject] = useState('');

  useEffect(() => {
    props.getReasonSupportAction();
  }, []);

  const newSupportHandlerClick = async () => {
    await props.newSupportAction({ comment, subject });
    setComment('');
    setSubject('');
  };

  return (
    <React.Fragment>
      <Comeback
        title={<IntlMessages id="communicationWithManagement" />}
        redirectLink={router.PROFILE}
      />
      <div style={{ margin: 10 }}>
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="info">
            <AlertTitle>
              <IntlMessages id="attention" />
            </AlertTitle>
            <IntlMessages id="communicationManagementMessage" />
          </Alert>
        </Stack>

        <div style={{ marginTop: 10 }}>
          <TextField
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            select
            fullWidth
            label={<IntlMessages id="subject" />}
            variant="filled"
          >
            {props.reasonSupport.map((option) => (
              <MenuItem
                key={option.vReasonSupportTitle}
                value={option.vReasonSupportTitle}
              >
                {option.vReasonSupportTitle}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            fullWidth
            required
            multiline
            minRows={13}
            margin="normal"
            label={<IntlMessages id="description" />}
            variant="filled"
          />
          <LoadingButton
            onClick={newSupportHandlerClick}
            loading={props.loadingBtn}
            disabled={!subject || !comment}
            variant="contained"
            fullWidth
            size="large"
            color="primary"
          >
            <IntlMessages id="sendMessage" />
          </LoadingButton>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    loadingBtn: state.common.loadingBtn,
    reasonSupport: state.field.reasonSupport,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newSupportAction: (data) => dispatch(info.newSupportAction(data)),
    getReasonSupportAction: () => dispatch(info.getReasonSupportAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationManagement);
